import React from "react"
import Img from "gatsby-image"
import { backdrop, backdropImg, closeBtn } from "./modal.module.scss"
import { motion } from "framer-motion"
import { BsX } from "react-icons/bs"

const Modal = ({ selectedImg, setSelectedImg }) => {
  const handleClick = e => {
    if (e.target.classList.contains(backdrop)) {
      setSelectedImg(null)
    }
  }

  const handleClose = e => {
    setSelectedImg(null)
  }

  const selectedImgFluid = selectedImg
    ? selectedImg.localFile.childImageSharp.fluid
    : selectedImg
  return (
    <motion.div
      className={backdrop}
      onClick={handleClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <BsX className={closeBtn} onClick={handleClose} />

      <Img
        alt="enlarged pic"
        fluid={selectedImgFluid}
        className={backdropImg}
        objectFit="contain"
      />
    </motion.div>
  )
}

export default Modal
